import { ACTIVE_CUSTOMER_DISPLAY } from 'redux/types'

export const setActiveCustomerDisplay = payload => {
  return {
    type: ACTIVE_CUSTOMER_DISPLAY,
    payload,
  }
}
